import styled from 'styled-components';
import OfferActionsDetail from './OfferActionsDetail';
import { colorSchema } from 'utils/style';

export default styled(OfferActionsDetail)`
  display: flex;
  height: 100%;

  .offer-actions {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
    width: 100%;

    &__primary {
      margin: 0 0 1rem 0;
      width: 100%;
    }

    &__blue-background {
      background-color: ${colorSchema('primary100')};
      color: ${colorSchema('primary900')};
    }

    &__secondary {
      width: 100%;
    }

    &__bidding {
      width: 100%;
      background-color: ${colorSchema('primary100')};
      margin-bottom: 0.8rem;
    }

    &__separator {
      width: 100%;
      margin: 0.8rem 0 1.6rem 0;
      border-bottom: 1px dashed ${colorSchema('grey700')};
    }

    &__error {
      padding: 0 2rem;
      svg {
        color: ${colorSchema('error700')};
      }
    }

    &__loading {
      padding: 0 2rem;
    }

    &__requested-container {
      background-color: ${colorSchema('grey700')};
      color: ${colorSchema('white')};
      display: flex;
      padding: 1.6rem;
      width: 100%;
    }

    &__requested-icon {
      align-items: flex-start;
      display: flex;
      margin-right: 1rem;
      svg {
        fill: ${colorSchema('white')};
      }
    }

    &__requested-title {
      align-items: center;
      color: ${colorSchema('white')};
      display: flex;
      font-weight: bold;
    }

    &__non-compliant-container {
      background-color: ${colorSchema('error500')};
      color: ${colorSchema('white')};
      display: flex;
      margin-top: 1.6rem;
      padding: 1.6rem;
      width: 100%;
      border-radius: 8px;
    }

    &__non-compliant-icon {
      align-items: flex-start;
      display: flex;
      margin-right: 1rem;
      svg {
        fill: ${colorSchema('white')};
      }
    }

    &__non-compliant-action {
      display: flex;
      padding-top: 1.6rem;
      width: 100%;
    }
  }
`;
